module.exports = __webpack_public_path__ + "3392dd4e9f92763d6d22fcb0c8511d58.png";